export default __webpack_public_path__ + "static/media/EquipoPesado_Icon.053ef66f.svg";